import React, { useEffect } from "react";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./contexts/AuthContext";
import Routes from "./Routes";

function App() {
  // Apply dark mode by default on app load
  useEffect(() => {
    // Add dark class to html element to enable dark mode
    document.documentElement?.classList?.add('dark');
    
    // Set theme preference in localStorage for persistence
    localStorage.setItem('theme', 'dark');
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground artist-gradient">
      <BrowserRouter>
        <AuthProvider>
          <Routes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;